// extracted by mini-css-extract-plugin
export default {"direct":"DirectContact_direct__Mztfc","icons":"DirectContact_icons__-5J6b"};